import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { animated, easings, useSpring } from 'react-spring';
import { CorrectnessIndicator } from '../components/CorrectnessIndicator';
import { CORRECT_ANSWER_ANIMATION_DURATION } from './constants';

export const CorrectAnswerBox = ({
  correctAnswer,
  shouldShowCorrectAnswer,
  left,
  shouldShow,
}: {
  correctAnswer: number;
  shouldShowCorrectAnswer: boolean;
  left: number;
  shouldShow: boolean;
}) => {
  const styles = useSpring({
    opacity: shouldShow ? 1 : 0,
    config: {
      duration: CORRECT_ANSWER_ANIMATION_DURATION,
      easing: easings.easeOutExpo,
    },
  });

  return (
    <animated.div style={{ opacity: styles.opacity }}>
      <Box
        position="absolute"
        top={0}
        left={left}
        bg="neutral"
        flexDirection="row"
        borderRadius="2xl"
        gap="8px"
        p="32px"
        style={{
          transform: 'translate(-50%, 0)',
        }}
      >
        <CorrectnessIndicator
          shouldShow={shouldShowCorrectAnswer}
          isCorrect={true}
          immediate={false}
          size="40px"
        />
        <Text fontSize="200">{correctAnswer}</Text>
      </Box>
    </animated.div>
  );
};
